import React from "react";
import { useSelector } from "react-redux";

const GlobalLoader = () => {
  const loading = useSelector((state) => state.loader.loading);

  if (!loading) return null;

  return (
    <div className="global-loader">
      <div className="loader-box">
        <div className="spinner-border text-success spinner-border-sm" />
        <span className="loader-text">Loading...</span>
      </div>
    </div>
  );
};

export default GlobalLoader;